import React, { useState } from "react";  
import {  
    CardHome,
    CardHomeHeader,
    CardHomeHeaderTitle,
    CardHomeBody,
    CardHomeHeaderActions,
    BackButton,
    CardHomeHeaderButton,
    ChevronButton
} from "./styled";

import Select from "components/Form/Select";
import { useHistory } from "react-router-dom";
import DashboardActions from "components/Dashboard/Actions";

export default function DashboardCardWrapper({ children, title, selectable, selectableOptional, selectableMonth, backable, closeable, actions, white, custom, loading }){  
    const history = useHistory();

    const [open, setOpen] = useState(true);

    return ( 
        <>
            <CardHome white={white}>
                {
                    (!title && !closeable && !backable && !selectable && !actions && !custom) ? null :
                        <CardHomeHeader>
                            <CardHomeHeaderButton>
                                { !closeable ? null : <ChevronButton open={open} onClick={() => setOpen(!open)} /> }
                                { !backable ? null : <BackButton onClick={() => history.goBack()} /> }
                                <CardHomeHeaderTitle>{ title }</CardHomeHeaderTitle>
                            </CardHomeHeaderButton>
                            {
                                !selectable ? null :
                                <CardHomeHeaderActions>
                                    <Select options={selectable?.options || []} { ...selectable } />
                                </CardHomeHeaderActions>
                            }
                            {
                                !selectableOptional ? null :
                                <CardHomeHeaderActions>
                                    <Select options={selectableOptional?.options || []} { ...selectableOptional } />
                                </CardHomeHeaderActions>
                            }
                            {
                                !selectableMonth ? null :
                                <CardHomeHeaderActions>
                                    <Select options={selectableMonth?.options || []} { ...selectableMonth } />
                                </CardHomeHeaderActions>
                            }
                            {
                                !actions ? null :
                                <DashboardActions actions={actions} loading={loading} />
                            }
                            { !custom ? null : custom }
                        </CardHomeHeader>
                }
                {
                    !open ? null : 
                    <CardHomeBody>
                        { children }
                    </CardHomeBody>
                }
            </CardHome>
        </>
    );
}

